"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurLocation() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223891" id="our-location" className="relative w-full min-h-[700px] flex items-center bg-background overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687251/img/blinklab_usa_network_map.png)] bg-cover bg-center opacity-40 grayscale-0 mix-blend-overlay" />
        
        {}
        <div className="absolute top-[45%] left-[75%] animate-pulse">
          <MapPin className="text-secondary size-8 drop-shadow-[0_0_10px_rgba(59,130,246,0.5)]" fill="currentColor" />
        </div>
        <div className="absolute top-[52%] left-[82%] animate-pulse" style={{
        animationDelay: "0.5s"
      }}>
          <MapPin className="text-primary size-12 drop-shadow-[0_0_15px_rgba(234,179,8,0.6)]" fill="currentColor" />
        </div>
        <div className="absolute top-[35%] left-[40%] animate-pulse" style={{
        animationDelay: "1s"
      }}>
          <MapPin className="text-secondary size-6 drop-shadow-[0_0_8px_rgba(59,130,246,0.4)]" fill="currentColor" />
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 relative z-10 flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-8">
        
        {}
        <div ref={leftRef} className={`w-full lg:w-1/2 flex justify-start transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <Card className="w-full max-w-md shadow-2xl bg-card/90 backdrop-blur-md border-border/40">
            <CardHeader className="pb-4">
              <CardTitle className="text-3xl font-default text-foreground">
                BlinkLab HQ
              </CardTitle>
              <CardDescription className="text-base text-muted-foreground">
                Based in Sumter, SC, powering small businesses with advanced digital solutions nationwide.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6 pt-2">
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <MapPin className="size-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Our Office
                  </h4>
                  <p className="text-muted-foreground leading-relaxed">
                    Sumter, South Carolina, USA
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Phone className="size-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Direct Line
                  </h4>
                  <p className="text-muted-foreground leading-relaxed">
                    Contact us for a consultation
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Mail className="size-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Email Us
                  </h4>
                  <p className="text-muted-foreground leading-relaxed">
                    hello@blinklabmedia.com
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-2 rounded-md shrink-0">
                  <Clock className="size-5 text-primary" />
                </div>
                <div>
                  <h4 className="font-default font-semibold text-foreground">
                    Agency Hours
                  </h4>
                  <p className="text-muted-foreground leading-relaxed">
                    Mon - Fri: 9:00 AM - 6:00 PM EST
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {}
        <div ref={rightRef} className={`w-full lg:w-1/2 flex justify-center lg:justify-end transition-all duration-1000 ease-out delay-200 ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <div className="bg-card/80 backdrop-blur-md p-8 rounded-lg shadow-2xl border border-border/40 max-w-sm text-center lg:text-left flex flex-col items-center lg:items-start">
            <h3 className="text-2xl font-default font-bold text-foreground mb-3">
              Nationwide Reach
            </h3>
            <p className="text-muted-foreground mb-8">
              While we call Sumter home, our digital expertise knows no borders. We build websites that work while you sleep, for clients across the entire US.
            </p>
            <Link to="/ContactPage" className="w-full sm:w-auto">
              <Button size="lg" className="w-full gap-2 text-base h-12 px-8 bg-primary text-primary-foreground font-bold rounded-md shadow-lg hover:shadow-primary/20 transition-all">
                Get Your Free Quote
                <ExternalLink className="size-4" />
              </Button>
            </Link>
          </div>
        </div>

      </div>
    </section>;
}